export default __webpack_public_path__ + "static/img2-97fd19b673653c8f1b2596f0692f7643.jpg";